import Forecast from "../instance/Forecast.js";
import ForecastReportTemplateInterpreter from "./ForecastReportTemplateInterpreter.js";
import ReportManager from "../instance/ReportManager.js";

/**
 * This class is responsible for converting a forecast template,
 * suitable for storage and user input, into a forecast, suitable for
 * rendering and calculation. An interpretation context (including,
 * e.g., a period and a company) drives the conversion.
 *
 * @param {ForecastTemplate} forecastTemplate - The template to
 * convert into a forecast
 * @param {ForecastTemplateInterpretationContext} interpretationContext - The data used to do the conversion
 */
export default class ForecastTemplateInterpreter {
	constructor({ forecastTemplate, interpretationContext }) {
		this._forecastTemplate = forecastTemplate;
		this._interpretationContext = interpretationContext;
	}

	interpret() {
		return new Forecast({
			forecastTemplate: this._forecastTemplate,
			reportManager: this._createReportManager(),
		});
	}

	_createReportManager() {
		return new ReportManager(this._interpretReportTemplates());
	}

	_interpretReportTemplates() {
		return ForecastReportTemplateInterpreter.interpret({
			forecastTemplate: this._forecastTemplate,
			forecastTemplateInterpretationContext: this._interpretationContext,
		});
	}

	static interpret(...spec) {
		return new this(...spec).interpret();
	}
}
